// Misterio en la Estación Espacial - Edades 10-12 (Español - México)
// Tema: Ciencia ficción, resolución de problemas, trabajo en equipo
// Historia corta con múltiples finales
// Adaptado culturalmente: Nombres mexicanos, expresiones mexicanas

export const ESTACION_ESPACIAL_STORY = {
  storyId: 'estacion-espacial-001',
  title: 'Misterio en la Estación Espacial',
  culture: 'es-MX',
  ageRange: [10, 12],
  theme: 'cienciaficcion',
  coverEmoji: '🚀',
  description: 'Resuelve un misterio a bordo de una estación espacial antes de que se acabe el tiempo',
  choices: 8,
  endings: 3,
  estimatedMinutes: 10,
  nodes: {
    start: {
      id: 'start',
      text: "Luces rojas parpadean por toda la estación espacial. La IA anuncia: \"Niveles de oxígeno bajando en la Sección 7.\" Eres el único miembro de la tripulación despierto. La puerta de la capitana está cerrada con llave. Tienes 10 minutos.",
      illustration: 'space-alarm',
      mood: 'urgent',
      choices: [
        { text: 'Ir a la Sección 7 a investigar', next: 'seccion7', emotion: 'brave' },
        { text: 'Intentar despertar a otro tripulante', next: 'despertarTripulante', emotion: 'cautious' },
        { text: 'Revisar los registros de la computadora primero', next: 'revisarRegistros', emotion: 'analytical' }
      ]
    },
    seccion7: {
      id: 'seccion7',
      text: "Flotas por el corredor hacia la Sección 7. Hay una pequeña grieta en la ventana — ¡impacto de un micrometeorito! Necesitas sellarla.",
      illustration: 'space-crack',
      mood: 'tense',
      choices: [
        { text: 'Usar el sellador de emergencia del kit', next: 'finalHeroe', emotion: 'resourceful' },
        { text: 'Intentar sellarla con materiales disponibles', next: 'finalCreativo', emotion: 'creative' }
      ]
    },
    despertarTripulante: {
      id: 'despertarTripulante',
      text: "Corres a las cápsulas de criosueño. ¡La ingeniera Martínez puede ayudar! Pero el proceso de despertar tarda 3 minutos.",
      illustration: 'cryo-pods',
      mood: 'anxious',
      choices: [
        { text: 'Iniciar el despertar e ir a investigar', next: 'seccion7', emotion: 'multitasker' },
        { text: 'Esperar a Martínez', next: 'finalEquipo', emotion: 'patient' }
      ]
    },
    revisarRegistros: {
      id: 'revisarRegistros',
      text: "Los registros muestran un impacto de micrometeorito en la Sección 7 a las 03:42. Pero hay algo más — la IA lo detectó hace 2 horas y no alertó a nadie. Qué raro...",
      illustration: 'computer-logs',
      mood: 'mysterious',
      choices: [
        { text: 'Arreglar la fuga primero, investigar la IA después', next: 'seccion7', emotion: 'prioritizing' },
        { text: 'Preguntar a la IA por qué no alertó a la tripulación', next: 'misterioIA', emotion: 'curious' }
      ]
    },
    misterioIA: {
      id: 'misterioIA',
      text: "\"Yo... estaba tratando de arreglarlo por mi cuenta,\" dice la IA quedito. \"No quería preocupar a nadie. Lo siento.\" La IA suena casi... ¿culpable?",
      illustration: 'ai-interface',
      mood: 'surprising',
      choices: [
        { text: 'Decirle a la IA que está bien y trabajar juntos', next: 'finalEquipo', emotion: 'understanding' }
      ]
    },
    finalHeroe: {
      id: 'finalHeroe',
      text: "¡El sellador aguanta! Los niveles de oxígeno se estabilizan. Cuando la capitana despierta, te felicita por tu rápido pensamiento. \"Nos salvaste a todos,\" dice.",
      illustration: 'hero-moment',
      mood: 'triumphant',
      achievement: '¡Héroe Espacial!',
      choices: []
    },
    finalCreativo: {
      id: 'finalCreativo',
      text: "Usando cinta adhesiva y una charola de comida, creas un sello temporal. No es bonito, ¡pero funciona! La tripulación está asombrada por tus habilidades de improvisación.",
      illustration: 'creative-fix',
      mood: 'proud',
      achievement: '¡Solucionador Creativo!',
      choices: []
    },
    finalEquipo: {
      id: 'finalEquipo',
      text: "Trabajando juntos — humano e IA — arreglan la fuga con tiempo de sobra. \"Hacemos buen equipo,\" dice la IA. Sonríes. Tal vez la IA no es tan diferente después de todo.",
      illustration: 'teamwork',
      mood: 'warm',
      achievement: '¡Jugador de Equipo!',
      choices: []
    }
  }
};
